import React, { useState, useEffect } from "react";
import { post, fetchJson } from "../../lib/Fetching";
import Button from "../Button";
import styled from "styled-components";

const DefaultContainer = styled.div`
  border-left: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;
  border-right: 1px solid #eeeeee;
  border-top: 1px solid #eeeeee;
  background-color: white;
  border-radius: 10px;
`;

const DefaultPaddedContainer = styled(DefaultContainer)`
  padding: 20px;
`;

export default function PrintAliquotBarcodes({ sampleIds = [], disabled, itemIds = [] }) {
  const [loading, setLoading] = useState(true);
  const [actualSampleIds, setActualSampleIds] = useState([]);
  const [highlighted, setHighlighted] = useState(false);
  const [tempDisable, setTempDisable] = useState(false);
  const [techniqueSteps, setTechniqueSteps] = useState([]);
  const [selectedTechniqueStepIds, setSelectedTechniqueStepIds] = useState([]);
  const [asReceivedSelected, setAsReceivedSelected] = useState(false);
  const [subcontractedAsReceivedSelected, setSubcontractedAsReceivedSelected] = useState(
    false
  );
  const [text, setText] = useState("Print Sample Aliquot Labels");

  useEffect(
    () => {
      setTechniqueSteps([]);
      setSelectedTechniqueStepIds([]);
      fetchJson("/scheduling/aliquot_technique_steps", {
        sample_ids: sampleIds,
        item_ids: itemIds,
      }).then((json) => {
        if (json.technique_steps) {
          setTechniqueSteps(json.technique_steps);
          setActualSampleIds(json.sample_ids);
        }
        setLoading(false);
      });
    },
    [sampleIds + itemIds]
  );

  const resetButton = () => {
    setTempDisable(false);
    setHighlighted(false);
    setText("Print Sample Aliquot Labels");
  };

  const printAliquots = () => {
    setText("Please wait...");
    setTempDisable(true);
    post("/printing/api/batch_print_sample_aliquots", {
      sample_ids: actualSampleIds,
      as_received: asReceivedSelected,
      subcontracted_as_received: subcontractedAsReceivedSelected,
      technique_step_ids: selectedTechniqueStepIds,
    })
      .then((json) => {
        if (json.errors) {
          alert(json.errors);
          resetButton();
        } else {
          setHighlighted(true);
          setText("Printed!!");
          setTimeout(() => {
            resetButton();
          }, 2000);
        }
        setTempDisable(false);
      })
      .catch((errors) => {
        alert(errors);
        resetButton();
      });
  };

  const toggleTechniqueStepId = (id) => {
    if (selectedTechniqueStepIds.includes(id)) {
      setSelectedTechniqueStepIds(selectedTechniqueStepIds.filter((tsId) => tsId !== id));
    } else {
      setSelectedTechniqueStepIds(selectedTechniqueStepIds.concat(id));
    }
  };

  if (sampleIds.length == 0 && itemIds.length == 0) {
    return (
      <DefaultPaddedContainer style={{ marginTop: 10 }}>
        <b>Print Aliquot Labels</b>
        <br />
        Nothing selected.
      </DefaultPaddedContainer>
    );
  }

  if (loading) {
    return (
      <DefaultPaddedContainer style={{ marginTop: 10 }}>
        <i className="fa fa-spinner fa-spin fa-spinner" />
        &nbsp; Loading...
      </DefaultPaddedContainer>
    );
  }

  return (
    <DefaultPaddedContainer style={{ marginTop: 10 }}>
      <b>Print Aliquot Labels</b>
      <p>
        Only labels for <b>scheduled</b> tests will be printed here.
      </p>
      <br />
      <label style={{ marginRight: 20 }}>
        <input
          type="checkbox"
          checked={asReceivedSelected}
          onChange={() => setAsReceivedSelected(!asReceivedSelected)}
        />
        &nbsp; As Received
      </label>
      <label style={{ marginRight: 20 }}>
        <input
          type="checkbox"
          checked={subcontractedAsReceivedSelected}
          onChange={() => setSubcontractedAsReceivedSelected(!subcontractedAsReceivedSelected)}
        />
        &nbsp; Subcontract Labels
      </label>
      {techniqueSteps.map((ts) => (
        <label style={{ marginRight: 20 }}>
          <input
            type="checkbox"
            checked={selectedTechniqueStepIds.includes(ts.id)}
            onChange={() => toggleTechniqueStepId(ts.id)}
          />
          &nbsp;
          {ts.name}
        </label>
      ))}
      <br />
      <Button
        tiny
        primary
        title={text}
        highlight={highlighted}
        disabled={
          tempDisable ||
          disabled ||
          (!asReceivedSelected &&
            !subcontractedAsReceivedSelected &&
            selectedTechniqueStepIds.length == 0)
        }
        onClick={printAliquots}
      />
    </DefaultPaddedContainer>
  );
}
